import BaseFile from '../entities/BaseFile';

export function getFileName({ name, extension }: BaseFile): string {
  return `${name}${extension}`;
}
